import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'grommet';
import { AddCircle } from 'grommet-icons';
import { FTSelect } from './inputs';
import { addError } from '../toasts/toasts.actions.js';

const AddableEventSelect = ({
  fieldBase,
  options,
  value,
  onChange,
  canEdit = true
}) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const allOptions = [...options];
  let matchingProperty = options.find(a => a.field === value);

  //user has input an option that does not exist in the index, just render it
  if (value && !matchingProperty) {
    matchingProperty = {
      field: value,
      displayName: value.split('.')[value.split('.').length - 1]
    };
    allOptions.push(matchingProperty);
  }

  const [filteredOptions, setFilteredOptions] = useState(allOptions);

  return (
    <FTSelect
      size='small'
      options={filteredOptions}
      labelKey='displayName'
      valueKey='field'
      disabled={!canEdit}
      icon={
        filteredOptions.length === 0 ? (
          <Button
            title='Add value'
            plain
            icon={<AddCircle size='small' />}
            onClick={() => {
              const propertyName = `${fieldBase}.${searchValue}`;
              onChange(propertyName);

              setFilteredOptions([
                {
                  field: propertyName,
                  displayName: searchValue
                },
                ...allOptions
              ]);
              setSearchValue('');
            }}
          />
        ) : (
          true
        )
      }
      value={matchingProperty}
      handleSearch={search => {
        if (search === '') {
          setFilteredOptions(allOptions);
        } else {
          setFilteredOptions(
            allOptions.filter(
              ap => ap.displayName.toLowerCase().indexOf(search) !== -1
            )
          );
        }
        setSearchValue(search);
      }}
      onChange={optionValue => {
        const addedField = optionValue?.field;
        if (
          addedField === undefined ||
          addedField.charAt(addedField.length - 1) === '.'
        ) {
          dispatch(addError('Error adding field', 'Field value is invalid'));
        } else {
          onChange(addedField);
        }
      }}
    />
  );
};

AddableEventSelect.displayName = 'AddableEventSelect';

export default AddableEventSelect;
